import { SvgIcon, SvgIconProps } from '@mui/material';

export const DrinkIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      xmlns='http://www.w3.org/2000/svg'
      height='24'
      viewBox='0 -960 960 960'
      width='24'
      fill='none'
      {...props}
    >
      <path d='M292.231-108.078q-26.734 0-45.927-17.363-19.192-17.363-22.034-43.175l-76.192-683.306h664.344l-75.808 683.306q-2.858 25.812-22.18 43.175-19.322 17.363-45.781 17.363H292.231Zm-56.77-465.038 44.77 398.308q.576 4.615 4.038 7.692 3.462 3.078 8.27 3.078h375.499q4.616 0 8.077-3.078 3.462-3.077 4.231-7.692l44.77-398.308H235.461Zm-6.884-55.96H732l17.077-166.886H210.538l18.039 166.886ZM479.938-278.5q-18.477 0-31.612-13.179-13.134-13.179-13.134-31.636 0-18.493 9.798-39.474 9.798-20.981 35.01-55.713 25.212 34.732 35.01 55.713 9.798 20.981 9.798 39.25 0 18.77-13.197 31.904-13.197 13.135-31.673 13.135Zm.062 55.96q42.277 0 71.523-29.19 29.246-29.189 29.246-71.612 0-35.235-22.039-75.812Q536.692-439.73 480-509.076q-56.692 69.346-78.73 109.986-22.039 40.64-22.039 75.889 0 42.44 29.246 71.55Q437.723-222.54 480-222.54Zm-229.153 58.502H709.73 250.847Z' />
    </SvgIcon>
  );
};
